import { App } from 'vue';
import { createRouter, RouteRecordRaw, createWebHistory } from 'vue-router';
import { RedirectRoute } from '@/router/base';
import { PageEnum } from '@/enums/pageEnum';
import { createRouterGuards } from './router-guards';
import { AppRouteRecordRaw } from './types';
import I18n from '@/plugins/i18n';
import { getAppEnvConfig } from '@/utils/env';
const { t } = I18n.global;
const modules = import.meta.globEager('./modules/**/*.ts');
const { VITE_GLOB_BASE_URL } = getAppEnvConfig();
const routeModuleList: RouteRecordRaw[] = [];

Object.keys(modules).forEach((key) => {
  const mod = modules[key].default || {};
  const modList = Array.isArray(mod) ? [...mod] : [mod];
  routeModuleList.push(...modList);
});

function sortRoute(a, b) {
  return (a.meta?.sort || 0) - (b.meta?.sort || 0);
}

routeModuleList.sort(sortRoute);

export const RootRoute: AppRouteRecordRaw = {
  path: '/',
  name: 'Root',
  redirect: PageEnum.BASE_HOME,
  meta: {
    title: 'Root',
  },
};

export const LoginRoute: AppRouteRecordRaw = {
  path: '/login',
  name: 'Login',
  // component: () => import('@/views/login/index.vue'),
  component: () => import('@/views/login/new.vue'),
  meta: {
    title: t('router.common.login'),
  },
};
export const LoginRouteNew: AppRouteRecordRaw = {
  path: '/login-new',
  name: 'LoginNew',
  component: () => import('@/views/login/new.vue'),
  meta: {
    title: t('router.common.login'),
  },
};
export const TestRoute: AppRouteRecordRaw = {
  path: '/test',
  name: 'Test',
  component: () => import('@/views/test/index/indexView.vue'),
  meta: {
    title: '测试路由',
    ignoreAuth: true,
  },
};
export const TableRoute: AppRouteRecordRaw = {
  path: '/table',
  name: 'Table',
  component: () => import('@/views/test/table/index.vue'),
  meta: {
    title: 'table',
    ignoreAuth: true,
  },
};

//需要验证权限
export const asyncRoutes = [...routeModuleList];

//普通路由 无需验证权限
export const constantRouter: any[] = [
  LoginRoute,
  LoginRouteNew,
  RootRoute,
  TestRoute,
  TableRoute,
  RedirectRoute,
];

const router = createRouter({
  history: createWebHistory(VITE_GLOB_BASE_URL || ''),
  routes: constantRouter,
  strict: true,
  scrollBehavior: () => ({ left: 0, top: 0 }),
});

export function setupRouter(app: App) {
  app.use(router);
  // 创建路由守卫
  createRouterGuards(router);
}

export default router;
